// extracted by mini-css-extract-plugin
export default {"bread-item":"MyBreadcrumb_bread-item__2skbe"};